export const splitFullName = (fullName: string) => {
  const parts = fullName.trim().split(/\s+/);

  if (parts.length === 1) {
    return {
      lastName: '',
      firstName: parts[0],
      middleName: '',
    };
  }

  return {
    lastName: parts[0] || '',
    firstName: parts[1] || '',
    middleName: parts[2] || '',
  };
};
